import { systemMap as applicationsMap } from '@tntx/logo-icon'
import cn from 'classnames'
import { get } from 'lodash'
import React, { useState } from 'react'
import styled from 'styled-components'
import Popover from '../popover'
import Iconfont from './Iconfont'
import { defaultLogo } from './images'

const App = styled.li`
  margin-left: 20px;
  font-size: 20px;
  cursor: pointer;
  .tnt-icon {
    color: #17233d99;
    .tnt-themeS1 & {
      color: rgba(255, 255, 255, 0.85);
    }
  }
`

const AppList = styled.ul`
  list-style: none;
  width: 264px;
  margin: 0;
  padding: 0;
`

const AppItem = styled.li`
  position: relative;
  width: 88px;
  padding: 8px 0;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  &:hover,
  &.active {
    background: #eee;
  }
  &.active:after {
    position: absolute;
    width: 0;
    height: 0;
    border-width: 5px 10px 0 0;
    border-color: #333;
    border-style: solid;
    z-index: 9;
  }
  img {
    width: 44px;
    height: 44px;
    margin-bottom: 6px;
  }
  div {
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

const AppContentWrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  z-index: 1;
`

const AppContent = (props) => {
  const { language, apps, onChange } = props
  const [appKey, setAppKey] = useState(props.appKey)
  const changeApp = (appKey) => {
    setAppKey(appKey)
    onChange && onChange(appKey)
  }

  return (
    <AppContentWrapper>
      <AppList>
        {apps
          .sort(
            (a, b) =>
              get(applicationsMap, `${a.appKey}.sort`, 1) -
              get(applicationsMap, `${b.appKey}.sort`, 1)
          )
          .map(({ appKey: key }) => (
            <AppItem
              key={key}
              className={cn({ active: appKey === key })}
              onClick={changeApp.bind(this, key)}
            >
              <img
                src={get(applicationsMap, `${key}.logo`, defaultLogo)}
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = defaultLogo
                }}
              />
              <div>
                {get(
                  applicationsMap,
                  `${key}.${
                    {
                      cn: 'name',
                      en: 'enName',
                    }[language || 'cn']
                  }`,
                  key
                )}
              </div>
            </AppItem>
          ))}
      </AppList>
    </AppContentWrapper>
  )
}

export default (props) => (
  <App>
    <Popover
      placement="bottomRight"
      title={null}
      content={<AppContent {...props} />}
      trigger="click"
    >
      <Iconfont type="application" />
    </Popover>
  </App>
)
